import React, { useRef, useEffect } from "react";
import ChatBubble from "../ChatBubble/ChatBubble";
import "./ChatSection.css";

interface Message {
  type: "bot" | "user";
  message: string;
  sender?: string;
  avatarPath?: string;
  userIconPath?: string;
  sources?: {
    name: string;
    url?: string;
    relevance_score: number;
    file_id?: string;
    page?: number;
    source_type?: string;
  }[];
  score?: string;
}

interface Collection {
  [key: string]: string;
}

interface ChatSectionProps {
  messages: Message[];
  modelName?: string;
  collections?: Collection[];
}

function ChatSection({ messages, modelName, collections }: ChatSectionProps) {
  const messageEndRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    messageEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  return (
    <div className="chat-section">
      {messages.map((msg, index) => (
        <ChatBubble
          key={index}
          type={msg.type}
          message={msg.message}
          sender={msg.sender}
          avatarPath={msg.avatarPath}
          userIconPath={msg.userIconPath}
          modelName={modelName || "All data collections"}
          sources={msg.sources}
          score={msg.score}
          isTyping={msg.message === "typing..."}
          collections={msg.type === "bot" ? collections : undefined}
        />
      ))}
      <div ref={messageEndRef}></div>
    </div>
  );
}

export default ChatSection;
